export default __webpack_public_path__ + "static/media/event-upcoming.cb4d9c84.png";